<i18n>
{
  "ja": {
    "meta": {
      "title": "ECの物流コストを削減！｜WareXで安く保管",
      "description": "WareXの「ECモール在庫保管サービス」は、Amazon・楽天に出店中のEC事業者を支援する物流サービス。EC在庫保管の新たな選択肢に。",
      "keywords": "EC,在庫保管"
    },
    "contact": "無料で相談する"
  }
}
</i18n>

<template>
  <div>
    <main class="kv relative px-8 max-w-full overflow-hidden flex items-center">
      <picture>
        <source srcset="@/assets/img/lp/ec-buffer/kv.webp" type="image/webp" media="(min-width: 768px)">
        <source srcset="@/assets/img/lp/ec-buffer/kv_sp.webp" type="image/webp" media="(max-width: 767px)">
        <source srcset="@/assets/img/lp/ec-buffer/kv_sp.jpg" media="(max-width: 767px)">
        <img class="absolute inset-0 w-full h-full object-cover" src="@/assets/img/lp/ec-buffer/kv.jpg" alt="">
      </picture>
      <div class="relative max-w-900 w-full mx-auto pt-24 pb-20 text-white z-10">
        <p class="mb-4"><img class="w-7/12 md:w-auto" src="@/assets/img/lp/ec-buffer/logo.svg" alt="WareX"></p>
        <h1 class="text-white text-22p md:text-34p font-medium mb-3">ECモール在庫保管サービス</h1>
        <p class="text-lg mb-5 leading-relaxed">Amazon、楽天等の在庫を安価に<br class="md:hidden">保管<br class="hidden md:block">在庫切れを防ぎます</p>
        <p class="text-lg hidden md:block">
          <a href="https://lp.warex.ai/ja-jp/contact-ec-buffer/" target="_blank" class="btn inline-flex items-center justify-center bg-orange text-white py-4 px-4 rounded-full">
            {{ $t('contact') }}
          </a>
        </p>
      </div>
    </main>
    <section class="py-16 px-8">
      <div class="max-w-900 mx-auto">
        <h2 class="text-xl md:text-28p text-black text-center mb-8 md:mb-12 font-bold leading-relaxed">
          <span class="border-b-3 md:border-b-4 border-orange">Amazon、楽天販売でこんな<br class="md:hidden" />お悩みありませんか？</span>
        </h2>
        <div class="bg-secondary-light rounded-30 mx-auto w-520 max-w-full text-center">
          <ul class="inline-block text-left md:text-22p pt-12 pb-10 px-6 md:pt-12 md:pb-8 font-bold text-black">
            <li class="flex items-center mb-4">
              <span class="bg-white rounded w-5 h-5 relative block mr-4 md:mr-6">
                <i class="material-icons text-orange text-4xl font-bold absolute inset-0 -ml-1 -mt-3">check</i>
              </span>
              在庫保管料が高い
            </li>
            <li class="flex items-center mb-4">
              <span class="bg-white rounded w-5 h-5 relative block mr-4 md:mr-6">
                <i class="material-icons text-orange text-4xl font-bold absolute inset-0 -ml-1 -mt-3">check</i>
              </span>
              納品できる在庫数に限りがある
            </li>
            <li class="flex items-center mb-4">
              <span class="bg-white rounded w-5 h-5 relative block mr-4 md:mr-6">
                <i class="material-icons text-orange text-4xl font-bold absolute inset-0 -ml-1 -mt-3">check</i>
              </span>
              コンテナのデバンニングが必要
            </li>
            <li class="flex items-center">
              <span class="bg-white rounded w-5 h-5 relative block mr-4 md:mr-6">
                <i class="material-icons text-orange text-4xl font-bold absolute inset-0 -ml-1 -mt-3">check</i>
              </span>
              FBA、RSLの納品作業が手間
            </li>
          </ul>
        </div>
        <p class="text-2xl md:text-32p text-center text-black mt-12 font-bold">
          <span class="border-b-3 md:border-b-6 border-orange">そのお悩み解決します！</span>
        </p>
      </div>
    </section>
    <section class="bg-primary-light py-12 md:pt-20 md:pb-16 px-8">
      <div class="max-w-900 mx-auto">
        <h3 class="text-center text-22p md:text-28p text-black font-bold mb-8 md:mb-10">WareX ECモール<br class="md:hidden" />在庫保管サービスの特徴</h3>
        <div class="md:flex justify-between tracking-normal">
          <div class="w-290 mx-auto mb-8 md:m-0 md:w-32p rounded-30 bg-secondary text-white text-center pb-12">
            <picture>
              <source srcset="@/assets/img/lp/ec-buffer/plan1.webp" type="image/webp">
              <img class="w-full" src="@/assets/img/lp/ec-buffer/plan1.png" width="290" height="193" loading="lazy" alt="">
            </picture>
            <p class="text-86p text-orange font-semibold font-sans leading-none -mt-10">1</p>
            <h4 class="text-white text-28p font-bold mb-3">
              <span class="border-b-4 border-orange">保管料が安い</span>
            </h4>
            <p class="text-lg font-bold">ECモールの1/5程度<br>
              初期・月額費用無料！</p>
          </div>
          <div class="w-290 mx-auto mb-8 md:m-0 md:w-32p rounded-30 bg-secondary text-white text-center pb-12">
            <picture>
              <source srcset="@/assets/img/lp/ec-buffer/plan2.webp" type="image/webp">
              <img class="w-full" src="@/assets/img/lp/ec-buffer/plan2.png" width="290" height="193" loading="lazy" alt="">
            </picture>
            <p class="text-86p text-orange font-semibold font-sans leading-none -mt-10">2</p>
            <h4 class="text-white text-28p font-bold mb-3">
              <span class="border-b-4 border-orange">納品の手間を削減</span>
            </h4>
            <p class="text-lg font-bold">デバンニングや<br>ラベル貼り付けも対応</p>
          </div>
          <div class="w-290 mx-auto mb-8 md:m-0 md:w-32p rounded-30 bg-secondary text-white text-center pb-12">
            <picture>
              <source srcset="@/assets/img/lp/ec-buffer/plan3.webp" type="image/webp">
              <img class="w-full" src="@/assets/img/lp/ec-buffer/plan3.png" width="290" height="193" loading="lazy" alt="">
            </picture>
            <p class="text-86p text-orange font-semibold font-sans leading-none -mt-10">3</p>
            <h4 class="text-white text-28p font-bold mb-3">
              <span class="border-b-4 border-orange">輸送料が安い</span>
            </h4>
            <p class="text-lg font-bold">FBA、RSLに<br />安価に発送</p>
          </div>
        </div>
        <p class="fukidashi text-center text-black mt-12 items-center justify-center hidden md:flex">お気軽にどうぞ</p>
        <p class="text-22p text-center mt-2 hidden md:block">
          <a href="https://lp.warex.ai/ja-jp/contact-ec-buffer/" target="_blank" class="btn inline-flex items-center justify-center bg-orange text-white py-4 px-10 rounded-full">
            物流コストについて相談する
          </a>
        </p>
      </div>
    </section>
    <section class="py-16 md:py-24 px-8">
      <div class="max-w-900 mx-auto">
        <h2 class="text-2xl md:text-4xl text-black text-center font-bold mb-4 leading-relaxed">
          <span class="border-b-4 border-orange">まだ売らない在庫は<br class="md:hidden" />WareXで安く保管</span>
        </h2>
        <p class="md:text-2xl text-black text-center mb-12 font-bold">大型商品の保管にも最適</p>
        <div class="md:flex justify-between">
          <div class="w-64 mx-auto mb-8 md:m-0 md:w-48p md:pl-4">
            <picture>
              <source srcset="@/assets/img/lp/ec-buffer/stock.webp" type="image/webp">
              <img class="mx-auto" src="@/assets/img/lp/ec-buffer/stock.png" width="360" height="410" loading="lazy" alt="">
            </picture>
          </div>
          <div class="w-64 mx-auto md:m-0 md:w-48p max-w-380 text-sm md:text-xl text-black font-bold">
            <div class="bg-gray-200 rounded-xxl md:rounded-30 py-4 px-8 md:py-8 md:px-12 mb-2">
              <p class="mb-3">ECモールの倉庫</p>
              <p class="text-right"><span class="leading-none text-28p md:text-43p mr-2">5,000</span>円/月</p>
            </div>
            <p class="text-orange text-25p md:text-38p font-bold flex items-center justify-center mb-2">
              <i class="material-icons text-5xl md:text-80p text-orange">arrow_drop_down</i>
              約1/5に!!
              <i class="material-icons text-5xl md:text-80p text-orange">arrow_drop_down</i>
            </p>
            <div class="bg-gray-200 rounded-xxl md:rounded-30 py-4 px-8 md:py-8 md:px-12">
              <p class="mb-2"><img class="w-32" src="@/assets/img/logotype_warex@2x.png" width="167" alt="WareX"></p>
              <p class="text-right"><span class="leading-none text-40p md:text-6xl text-secondary-light mr-2">900</span>円/月</p>
            </div>
          </div>
        </div>

        <h2 class="text-2xl md:text-4xl text-black text-center font-bold mb-4 mt-24 leading-relaxed">
          <span class="border-b-4 border-orange">複数モールの<br class="md:hidden" />在庫を管理</span>
        </h2>
        <p class="md:text-2xl text-black text-center mb-4 font-bold">在庫が切れそうになったら、<br class="md:hidden" />WareXからすぐに発送</p>
        <picture>
          <source srcset="@/assets/img/lp/ec-buffer/figure.webp" type="image/webp">
          <img class="mx-auto sm:max-w-380 md:max-w-full" src="@/assets/img/lp/ec-buffer/figure.png" width="903" height="638" loading="lazy" alt="">
        </picture>

        <h2 class="text-2xl md:text-4xl text-black text-center font-bold mb-4 mt-10 md:-mt-12 leading-relaxed">
          <span class="border-b-4 border-orange">全国の倉庫が<br class="md:hidden" />利用可能</span>
        </h2>
        <p class="md:text-2xl text-black text-center mb-8 font-bold">納品時の輸送費が安くなる<br class="md:hidden" />場所に倉庫を確保</p>
        <picture>
          <source srcset="@/assets/img/lp/ec-buffer/map.webp" type="image/webp">
          <img class="mx-auto sm:max-w-380 md:max-w-full" src="@/assets/img/lp/ec-buffer/map.png" width="613" height="508" loading="lazy" alt="">
        </picture>

        <p class="fukidashi text-center text-black mt-24 items-center justify-center hidden md:flex">お気軽にどうぞ</p>
        <p class="text-22p text-center mt-2 hidden md:block">
          <a href="https://lp.warex.ai/ja-jp/contact-ec-buffer/" target="_blank" class="btn inline-flex items-center justify-center bg-orange text-white py-4 px-10 rounded-full">
            倉庫について相談する
          </a>
        </p>
      </div>
    </section>
    <section class="bg-secondary py-16 md:py-24 px-8">
      <div class="max-w-900 mx-auto">
        <h3 class="text-black text-28p text-center font-bold">ご利用料金</h3>
        <p class="text-black text-lg text-center font-bold mb-10">※参考価格</p>
        <div class="text-center bg-white rounded-30 max-w-600 mx-auto p-8 md:p-16">
          <dl class="md:flex justify-between text-black border-b border-gray-500 pb-4 mb-6">
            <dt class="font-bold text-29p">初期費用</dt>
            <dd class="font-bold text-orange text-4xl">無料</dd>
          </dl>
          <dl class="md:flex justify-between text-black border-b border-gray-500 pb-4 mb-6">
            <dt class="font-bold text-29p">月額固定費用</dt>
            <dd class="font-bold text-orange text-4xl">無料</dd>
          </dl>
          <dl class="md:flex justify-between text-black border-b border-gray-500 pb-6 mb-6">
            <dt class="font-bold text-29p">保管料</dt>
            <dd class="mt-4 md:mt-0 md:text-right">
              <p class="text-22p">140サイズ段ボール<span class="block md:inline-block md:ml-4">90円／月</span></p>
              <p class="font-yakuhan text-sm mt-2 md:mt-0">（参考）ECモール　500円〜800／月</p>
              <p class="font-yakuhan text-sm mt-2 md:mt-0">※利用する倉庫により変動します</p>
            </dd>
          </dl>
          <dl class="md:flex justify-between text-black">
            <dt class="font-bold text-29p">別途お見積り</dt>
            <dd class="font-medium mt-4 md:mt-0">
              <ul class="inline-block text-left text-22p">
                <li>●入出荷作業料</li>
                <li>●ラベル貼り</li>
                <li>●デバンニングなど</li>
              </ul>
            </dd>
          </dl>
        </div>
        <p class="fukidashi text-center text-black mt-12 items-center justify-center hidden md:flex">お気軽にどうぞ</p>
        <p class="text-22p text-center mt-2 hidden md:block">
          <a href="https://lp.warex.ai/ja-jp/contact-ec-buffer/" target="_blank" class="btn inline-flex items-center justify-center bg-orange text-white py-4 px-10 rounded-full">
            {{ $t('contact') }}
          </a>
        </p>
      </div>
    </section>
    <div class="z-10 sticky bottom-0 left-0 bg-secondary py-4 w-full md:hidden">
      <p class="fukidashi text-xs text-center text-black flex items-center justify-center">お気軽にどうぞ</p>
        <p class="text-lg text-center mt-2">
          <a href="https://lp.warex.ai/ja-jp/contact-ec-buffer/" target="_blank" class="inline-flex items-center justify-center bg-orange text-white py-4 px-10 rounded-full">
            {{ $t('contact') }}
          </a>
        </p>
    </div>
    <BreadcrumbsFoot :list="breadcrumbs" />
  </div>
</template>

<script>
  import Jsonld from '@/components/mixins/jsonld';
  import BreadcrumbsFoot from '@/components/breadcrumbsFoot';
  import ogimg from '@/assets/img/lp/ec-buffer/ogp.png'
  export default {
    mixins: [Jsonld],
    components: { BreadcrumbsFoot },
    data() {
      return {
        breadcrumbs: [
          { name: this.$t('meta.title') }
        ]
      }
    },
    computed: {
      global() {
        return this.$store.getters['cms/global']
      }
    },
    head() {
      const title = this.$t('meta.title')
      const { defaultSeo } = this.global;
      const fullSeo = {
        ...defaultSeo,
        metaTitle: title,
        metaDescription: this.$t('meta.description'),
        metaKeywords: `${this.$t('meta.keywords')},${this.$t('keywords')}`
      };
      if (!!ogimg) {
        fullSeo.shareImage = {
          url: this.$seo.url(ogimg)
        }
      }
      return {
        titleTemplate: '',
        title,
        meta: this.$options.filters.cmsMetaTags(fullSeo)
      };
    },
    jsonld() {
      const ret = []
      const breadcrumbs = this.getBreadcrumbsJsonld(this.breadcrumbs)
      breadcrumbs && ret.push(breadcrumbs)
      return ret
    }
  };
</script>

<style lang="sass" scoped>
.kv
  min-height: 470px
  @screen md
    min-height: 0
  &::before
    content: ''
    background-color: rgba(#000, 0.4)
    z-index: 1
    @apply absolute inset-0 w-full h-full
  .btn
    min-width: 150px
.fukidashi
  &::after,
  &::before
    content: ''
    width: 1px
    height: 20px
    @apply bg-black inline-block mx-4 transform rotate-25
  &::before
    @apply -rotate-25
</style>